import { useState } from "react";
import { RateProductItem } from "../../components/RateProductItem";
import Typography from "../../components/Typography/Typography"
import styles from "./style.module.css"
import FlatButtons from "../../components/FlatButton/FlatButton";
import { productImg, storeImg } from "../../assets/images";

export const BuyerReviewPage: React.FC = () => {

    const [store, setStore] = useState(false)

    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2);

        return `${day}-${month}-${year}`;
    }

    // Example usage:
    console.log(formatDate(new Date()));

    const storeItems = [
        {
            items: 4,
            storeVisits: 10,
            id: "123456",
            name: "Akado Children Store",
            image:
                "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 7,
            storeVisits: 15,
            id: "234567",
            name: "Urban Wear Hub",
            image: storeImg
            // "https://images.unsplash.com/photo-1520974735194-6c5c3a6f27c4?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 12,
            storeVisits: 22,
            id: "345678",
            name: "Denim & Co.",
            image: storeImg
            // "https://images.unsplash.com/photo-1618354691329-4b8e7d8e6d42?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 6,
            storeVisits: 18,
            id: "456789",
            name: "RunFast Sneakers",
            image: storeImg
            // "https://images.unsplash.com/photo-1600185365524-6f3aee5e79ca?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 10,
            storeVisits: 30,
            id: "567890",
            name: "LeatherCraft Bags",
            image:
                "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 8,
            storeVisits: 12,
            id: "678901",
            name: "Classic Polo Store",
            image:
                "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 5,
            storeVisits: 8,
            id: "789012",
            name: "Winter Woolies",
            image:
                "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=200&h=200&fit=crop&crop=center",
        },
        {
            items: 9,
            storeVisits: 20,
            id: "890123",
            name: "Sunny Shades",
            image:
                "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=200&h=200&fit=crop&crop=center",
        },
    ];


    const productItems = [
        {
            id: "123456",
            deliveryDate: formatDate(new Date()),
            name: "Crew Neck Long Sleeve Shirt",
            image:
                "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "234567",
            deliveryDate: formatDate(new Date()),
            name: "Classic Denim Jacket",
            image: productImg
            // "https://images.unsplash.com/photo-1520974735194-6c5c3a6f27c4?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "345678",
            deliveryDate: formatDate(new Date()),
            name: "Slim Fit Chinos",
            image: productImg
            // "https://images.unsplash.com/photo-1618354691329-4b8e7d8e6d42?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "456789",
            deliveryDate: formatDate(new Date()),
            name: "Running Sneakers",
            image: productImg
            // "https://images.unsplash.com/photo-1600185365524-6f3aee5e79ca?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "567890",
            deliveryDate: formatDate(new Date()),
            name: "Leather Backpack",
            image:
                "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "678901",
            deliveryDate: formatDate(new Date()),
            name: "Cotton Polo Shirt",
            image:
                "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "789012",
            deliveryDate: formatDate(new Date()),
            name: "Wool Beanie",
            image:
                "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=200&h=200&fit=crop&crop=center",
        },
        {
            id: "890123",
            deliveryDate: formatDate(new Date()),
            name: "Aviator Sunglasses",
            image:
                "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=200&h=200&fit=crop&crop=center",
        },
    ];


    return (
        <div className={styles.container}>

            <div className={styles.subContainer}>

                <div className={styles.reviewTitle}>
                    <Typography
                        variant="heading6"
                    >
                        Reviews (20)
                    </Typography>
                </div>

                <div className={styles.innerContainer}>

                    <div className={styles.rateContainer}>
                        <FlatButtons
                            onClick={() => { setStore(false) }}
                            className={`${styles.rateProduct} ${!store ? styles.activeBtn : ""}`}
                        >
                            <Typography>
                                Rate Product (14)
                            </Typography>
                        </FlatButtons>
                        <FlatButtons
                            onClick={() => { setStore(true) }}
                            className={`${styles.rateProduct} ${store ? styles.activeBtn : ""}`}
                        >
                            <Typography>
                                Rate Stores (6)
                            </Typography>
                        </FlatButtons>

                    </div>

                    <div className={styles.products}>

                        {store ? storeItems.map((item) => (
                            <RateProductItem
                                name={item.name}
                                id={item.id}
                                storeVisits={item.storeVisits}
                                items={item.items}
                                image={item.image}
                                route={`/buyer-rate/${item.id}`}
                                product={store}
                            />
                        )) :
                            productItems.map((item) => (
                                <RateProductItem
                                    name={item.name}
                                    id={item.id}
                                    deliveryDate={item.deliveryDate}
                                    image={item.image}
                                    route={`/buyer-rate/${item.id}`}
                                    product={store}
                                />
                            ))
                        }

                    </div>

                </div>

            </div>
            
        </div>
    )
}